module.exports = __webpack_public_path__ + "img/nine-o'clock.340de7b5.png";